var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 9.33301H24.5002C25.3756 9.33301 26.2425 9.50545 27.0514 9.84048C27.8602 10.1755 28.5951 10.6666 29.2142 11.2856C29.8333 11.9047 30.3243 12.6396 30.6594 13.4485C30.9944 14.2573 31.1668 15.1242 31.1668 15.9997C31.1668 16.8752 30.9944 17.7421 30.6594 18.5509C30.3243 19.3597 29.8333 20.0947 29.2142 20.7137C28.5951 21.3328 27.8602 21.8238 27.0514 22.1589C26.2425 22.4939 25.3756 22.6663 24.5002 22.6663H20.5002M12.5002 22.6663H8.50016C7.62468 22.6663 6.75778 22.4939 5.94894 22.1589C5.1401 21.8238 4.40517 21.3328 3.78612 20.7137C2.53587 19.4635 1.8335 17.7678 1.8335 15.9997C1.8335 14.2316 2.53587 12.5359 3.78612 11.2856C5.03636 10.0354 6.73205 9.33301 8.50016 9.33301H12.5002",
    stroke: "#090909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1665 16H21.8332",
    stroke: "#090909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.059de5516c439ba395fdac1989e66b56.svg";
export { ForwardRef as ReactComponent };